var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM11.75 18.75C12.3713 18.75 12.875 18.2463 12.875 17.625C12.875 17.0037 12.3713 16.5 11.75 16.5C11.1287 16.5 10.625 17.0037 10.625 17.625C10.625 18.2463 11.1287 18.75 11.75 18.75ZM12.5 6.00001H11.375C10.4793 5.99801 9.61969 6.35295 8.98632 6.98632C8.35295 7.61969 7.99801 8.47929 8.00001 9.37501V9.75001H9.50001V9.37501C9.50001 8.33947 10.3395 7.50001 11.375 7.50001H12.5C13.5355 7.50001 14.375 8.33947 14.375 9.37501C14.375 10.4105 13.5355 11.25 12.5 11.25H11V14.625H12.5V12.75C14.364 12.75 15.875 11.239 15.875 9.37501C15.875 7.51105 14.364 6.00001 12.5 6.00001ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/help.1391558384deffeab30412a66447a601.svg";